/**
 * Wanedc Transparent Header
 *
 * 让官方页头在首页顶部透明、滚动超过阈值后恢复实色，不改官方组件。
 * - 仅当首个内容 section 内是 Wanedc Hero Carousel 时，给 <html> 加 wanedc-th-enabled
 * - 滚动超过 data-threshold 时加 wanedc-th-solid
 * - 桌面（≥990px）页面滚动容器是 .page-wrapper，用捕获阶段监听 scroll 同时覆盖两种情况
 */
(() => {
  if (window.__wanedcTransparentHeader) return;
  window.__wanedcTransparentHeader = true;

  const ENABLED = 'wanedc-th-enabled';
  const SOLID = 'wanedc-th-solid';
  const SQUEEZE = '(min-width: 990px)';

  let raf = 0;
  let solid = null;

  function getRoot() {
    return document.querySelector('[data-wanedc-transparent-header]');
  }

  function qualifies() {
    const first = document.querySelector('.content-for-layout > .shopify-section:first-child');
    return !!(first && first.querySelector('[data-wanedc-hero-carousel]'));
  }

  function getScrollTop() {
    if (window.matchMedia(SQUEEZE).matches) {
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper) return wrapper.scrollTop;
    }
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function update() {
    raf = 0;
    if (!document.documentElement.classList.contains(ENABLED)) return;
    const root = getRoot();
    if (!root) return;
    const threshold = parseInt(root.dataset.threshold || '40', 10) || 0;
    const next = getScrollTop() > threshold;
    if (next === solid) return;
    solid = next;
    document.documentElement.classList.toggle(SOLID, next);
  }

  function schedule() {
    if (!raf) raf = requestAnimationFrame(update);
  }

  function refresh() {
    const html = document.documentElement;
    if (getRoot() && qualifies()) {
      if (typeof window.measureHeaderHeights === 'function') window.measureHeaderHeights();
      html.classList.add(ENABLED);
      solid = null;
      update();
    } else {
      html.classList.remove(ENABLED, SOLID);
      solid = null;
    }
  }

  // 捕获阶段监听：桌面 .page-wrapper 与移动端 document 的滚动都能收到
  document.addEventListener('scroll', schedule, { capture: true, passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  document.addEventListener('shopify:section:load', refresh);
})();
